import { useMemo } from "react";
import { usePermissions } from "../../hooks/usePermissions";

export const useHasReportsAccess = () => {
  const { hasAccess } = usePermissions();

  const canViewReports: boolean = useMemo(
    () =>
      hasAccess("ReportGeneration", "TicklersReport") ||
      hasAccess("ImpoundBalancesExcelReport", "Get") ||
      hasAccess("Export", "BulkCoupons") ||
      hasAccess("Export", "BulkTax1098") ||
      hasAccess("Export", "IncidentReports") ||
      hasAccess("Export", "ContractFees") ||
      hasAccess("Export", "CustomerZipCodeRanks") ||
      hasAccess("Export", "ConversationMessages"),
    [hasAccess],
  );

  return { canViewReports };
};
